import { Navigate } from '@tanstack/react-router';

import { StudioLayout } from '@/shared/layout/studio-layout';
import { useStudio } from '@/shared/program/use-studio';
import { activityHref } from '@/shared/ui/activity/activity-kind';
import { Alert } from '@/shared/ui/alert';
import { Button } from '@/shared/ui/button';
import { EmptyState } from '@/shared/ui/empty-state';
import { LoadingStatus } from '@/shared/ui/spinner';

import { useStudioResumeTarget } from '../api/use-studio-resume-target';

/** Studio is an entry into the last activity; the curriculum panel owns browsing. */
export function StudioPage() {
  const studio = useStudio();
  const resume = useStudioResumeTarget(studio.data);
  if (resume.target && !studio.error)
    return <Navigate to={activityHref(resume.target.kind, resume.target.id)} replace />;

  return (
    <StudioLayout
      activeId={null}
      subtitle="Resume Studio"
      content={
        !studio.error ? (
          <div className="p-5 sm:p-8">
            {resume.error ? (
              <div className="max-w-lg space-y-4">
                <Alert>Could not check where you left off. {resume.error.message}</Alert>
                <p className="text-fg-muted text-sm">
                  Try again, or choose an activity from the curriculum.
                </p>
                <Button variant="secondary" onClick={resume.retry}>
                  Try again
                </Button>
              </div>
            ) : resume.pending ? (
              <LoadingStatus label="Opening your last activity…" />
            ) : (
              <EmptyState
                title="Your Studio is ready"
                description="Your lessons and workshops will appear in the curriculum when they become available."
              />
            )}
          </div>
        ) : (
          <></>
        )
      }
    />
  );
}
